// extracted by css-extract-rspack-plugin
export default {"container":"t6m0s32Ah5gem__9","lobby":"lCf8emUlAdseh6hd","list":"ihLhgAI5KEkKjEKL"};